export default {
  GET_DISTRICTS: 'GET_DISTRICTS',
  GET_DISTRICT_BYID: 'GET_DISTRICT_BYID',
  GET_DISTRICT_BYCODE: 'GET_DISTRICT_BYCODE',
  SAVE_DISTRICT: 'SAVE_DISTRICT',
  DELETE_DISTRICT: 'DELETE_DISTRICT'
}
